import { cn } from '@/utils/cn';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  className?: string;
}

export const Switch = ({
  checked,
  onChange,
  size = 'md',
  disabled = false,
  className = '',
}: SwitchProps) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  // Define the size classes
  const sizeClasses = {
    sm: { switch: 'w-8 h-4', circle: 'w-4 h-4', translateX: 16 },
    md: { switch: 'w-10 h-5', circle: 'w-5 h-5', translateX: 20 },
    lg: { switch: 'w-12 h-6', circle: 'w-6 h-6', translateX: 24 },
  };

  const { translateX } = sizeClasses[size];

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      aria-pressed={checked}
      className={cn(
        'relative inline-flex shrink-0 items-center',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className,
      )}
    >
      <span
        className={cn(
          sizeClasses[size].switch,
          'relative overflow-hidden rounded-full transition-colors duration-200',
          checked ? 'bg-linko-light' : 'bg-gray-200',
        )}
      >
        {/* Switch circle */}
        <span
          className={cn(
            sizeClasses[size].circle,
            'absolute left-0 top-0 flex items-center justify-center rounded-full bg-white shadow-md transition-transform duration-200',
          )}
          style={{ transform: `translateX(${checked ? translateX : 0}px)` }}
        ></span>
      </span>
    </button>
  );
};
